import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ComprobanteVinculadoDto } from '@models/base/comprobanteVinculadoDto.model';
import { PeriodoContratoDetailDto } from '@models/periodos-contrato/periodoContratoDetailDto.model';
import { ComprobantesService } from '@services/comprobantes/comprobantes.service';
import { PeriodosContratoService } from '@services/periodos-contrato/periodos-contrato.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogComprobanteComponent } from '@views/comprobantes/dialog-comprobante/dialog-comprobante.component';

@Component({
  selector: 'app-dialog-ver-periodo-contrato-detail-dto',
  templateUrl: './dialog-ver-periodo-contrato-detail-dto.component.html',
  styleUrls: ['./dialog-ver-periodo-contrato-detail-dto.component.css'],
})
export class DialogVerPeriodoContratoDetailDtoComponent implements OnInit {

  comprobantesVinculados: ComprobanteVinculadoDto[] = []
  displayedColumnsComprobantes: string[] = ['tipoComprobante', 'nroComprobante', 'fechaEmision', 'estadoComprobante', 'importeImputado', 'accion'];

  constructor(
    public dialogRef: MatDialogRef<DialogVerPeriodoContratoDetailDtoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public periodoContratoDetail: PeriodoContratoDetailDto,
    private periodosContratoService: PeriodosContratoService,
    private comprobantesService: ComprobantesService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.getComprobantesVinculados()
  }

  getComprobantesVinculados() {
    if (!this.periodoContratoDetail?.id)
      return

    this.periodosContratoService.getComprobantesVinculados(this.periodoContratoDetail.id)
      .subscribe(
        data => {
          this.comprobantesVinculados = data ?? []
        },
        error => {
          this.snackBar.showError(error, "Error");
        })
  }

  /** Abre el comprobante vinculado en su propio diálogo */
  verComprobante(vinculo: ComprobanteVinculadoDto) {
    this.spinner.show("spPeriodoContrato")
    this.comprobantesService.getById(vinculo.idComprobante)
      .subscribe(
        data => {
          this.spinner.hide("spPeriodoContrato")

          const dialogConfig = new MatDialogConfig();
          dialogConfig.autoFocus = false;
          dialogConfig.width = "70%";
          dialogConfig.data = data;

          this.dialog.open(DialogComprobanteComponent, dialogConfig);
        },
        error => {
          this.spinner.hide("spPeriodoContrato")
          this.snackBar.showError(error, "Error");
        })
  }

  /** Las fechas sin cargar vienen como 01/01/0001 desde la API */
  esFechaValida(fecha: any): boolean {
    if (!fecha)
      return false

    return fecha !== '01/01/0001' && !String(fecha).startsWith('0001-01-01')
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  trackByItems(index: number, item: any): any { return item; }
}
